import { makeStyles, withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import { Tag } from "antd";
import React from "react";
import "../.././App.css";

const CustomToolTip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#344563",
    color: "#FFFFFF",
    fontSize: 10,
    fontWeight: 600,
    fontFamily: "inter",
  },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
  red: {
    fontSize: 10,
    fontWeight: 600,
    color: "#B92500",
    fontFamily: "inter",
  },
  green: {
    fontSize: 10,
    fontWeight: 600,
    color: "#006644",
    fontFamily: "inter",
  },
  yellow: {
    fontSize: 10,
    fontWeight: 600,
    color: "#172B4D",
    fontFamily: "inter",
  },
}));

function OrderStatusText(props) {
  const classes = useStyles();

  return (
    <>
      {props.text !== undefined ? (
        <>
          <CustomToolTip title={props.text}>
            {
              <Tag
                color={
                  props.text.toLowerCase().startsWith("cancelled") ||
                  props.text.toLowerCase().startsWith("returned")
                    ? "red"
                    : props.text.toLowerCase().startsWith("shipped") ||
                      props.text.toLowerCase().startsWith("delivered")
                    ? "green"
                    : props.text.toLowerCase().startsWith("pending") ||
                      props.text.toLowerCase().startsWith("ready_to_dispatch")
                    ? "gold"
                    : "blue"
                }
              >
                {props.text.replace(/(.{8})..+/, "$1…")}
              </Tag>
            }
          </CustomToolTip>
        </>
      ) : null}
    </>
  );
}

export default OrderStatusText;
